<template>

    <div :class="{ 'pointer-events-none': !$page.props.canManageSettings }">

        <a v-if="trigger" href="#" @click.prevent.stop="toggle" class="flex items-center flex-row">
            <div class="flex flex-grow items-center font-medium">
                <img src="/img/slack.svg" class="h-5 w-5 mr-2" />
                Receive recordings via Slack<sup class="text-red-500">*</sup>
            </div>
            <div class="flex">
                <toggle :checked="enabled" @click.prevent.stop @update="toggleSlack"></toggle>
            </div>
        </a>
        <div v-else class="flex items-center font-medium">
            <img src="/img/slack.svg" class="h-5 w-5 mr-2" />
            Receive recordings via Slack
        </div>

        <div v-if="trigger" class="flex flex-col mt-3 text-sm">
            <div class="flex items-center">
                Recordings will be sent to {{ engine.incoming_webhook.channel }} | <a href="#"
                    @click.prevent="deleteTrigger()" title="Disconnect Slack"
                    class="text-blue-500 mx-1 hover:underline hover:text-blue-600">disconnect</a>
            </div>
            <div class="flex justify-start text-sm text-gray-600 mt-3">
                <span class="text-red-500">*</span><em>If you connected {{ app_name }} to a <strong>private
                        channel</strong>, you must invite our bot named <span class="font-bold mx-1">@{{ app_name }}
                        Post</span> right into this channel to allow posting.</em>
            </div>
        </div>

        <div v-else class="flex flex-row mt-2">
            <div class="flex flex-grow items-center">
                Recordings will be sent to a #channel in your workspace
            </div>
            <div class="flex">
                <a href="/auth/service/slack" title="Add to Slack">
                    <img alt="Add to Slack" height="40" width="139"
                        src="https://platform.slack-edge.com/img/add_to_slack.png"
                        srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" />
                </a>
            </div>
        </div>




    </div>

</template>

<script>
import Toggle from '@/Components/UI/Toggle'

export default {

    props: ['the_trigger'],

    components: {
        Toggle
    },

    created: function () {
        if (this.the_trigger) {
            this.trigger = this.the_trigger
            this.engine = JSON.parse(this.the_trigger.engine)
        }
    },

    data() {
        return {
            trigger: null,
            engine: {},
            app_name: this.$page.props.app_name
        }
    },

    mounted: function () {
        //console.log(this.engine);
    },

    methods: {
        toggleSlack: function (checked) {
            this.trigger.enabled = checked ? 1 : 0
            this.updateTrigger()
        },
        toggle: function () {
            if (this.trigger.enabled == 1) {
                this.trigger.enabled = 0;
            } else {
                this.trigger.enabled = 1;
            }
            this.updateTrigger();
        },
        deleteTrigger: function () {
            if (!this.$page.props.canManageSettings) {
                return
            }
            let url = this.$page.props.api_url + '/v1/trigger/' + this.trigger.id + '/delete';
            var params = {};
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    this.trigger = null
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Saved", options)
                })
                .catch(e => {
                    console.error(e);
                });
        },
        updateTrigger: function () {
            if (!this.$page.props.canManageSettings) {
                return
            }
            let url = this.$page.props.api_url + '/v1/trigger/' + this.trigger.id;
            var params = {
                enabled: this.trigger.enabled
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                })
                .catch(e => {
                    console.error(e);
                });
        }
    },

    computed: {
        enabled: {
            get: function () {
                return this.trigger.enabled == 1
            },
            set: function (newValue) {
                // do nothing
            }
        }
    }
}

</script>

<style scoped>
a.title {
    display: block;
    text-decoration: none;
    color: rgb(32, 41, 50);
}
</style>
